module.exports = vendors_fcac440f0d542e70f5fd;